/*
  stem
* choices
* correctAnswer
* userAnswer
* category: radio/multi //单选还是双选
* */

import React ,{Component} from 'react';
import Material from 'components/Practice/Material';
import style from './question.css';
import AnswerAnalysis from 'components/Practice/Material/AnswerAnalysis.js'

export default class ChooseQuestion extends Component {
  render() {
    let {stem,choices,correctAnswer,userAnswer,category} = this.props;
    let userAnswerArr;
    if(!userAnswer) {
      userAnswer = {
        answer: ''
      }
    }
    if(category === 'multi') {
      userAnswerArr = userAnswer.answer.split(',');
    }
    return (
      <div className={style.chooseQuestionBox}>
        <Material stem={stem}/>
        <ul className={style.ulList}>
          {
            choices.map((item,index)=> {
              if(category === 'radio') {
                return (
                  <li key={index} className={style.choicesItem}>
                    <span className={parseInt(userAnswer.answer, 10) === index ?style.myAnswerButton :style.radioButton}></span>
                    <span className={correctAnswer === index ? style.correctText : (parseInt(userAnswer.answer, 10) === index ? style.myAnswerText :style.choicesText)}>
                      {String.fromCharCode(index + 65)}. {item}
                    </span>
                  </li>
                )
              }else if(category === 'multi') {
                let button = null,text = null;
                for(let i = 0;i<userAnswerArr.length;i++) {
                  for(let j = 0; j<correctAnswer.length; j++ ) {
                    if(parseInt(correctAnswer[j], 10) === index) {
                      text = (
                        <span className={style.correctText}>
                          {String.fromCharCode(index + 65)}. {item}
                        </span>
                      );
                      break;
                    }else {
                      text = (
                        <span className={parseInt(userAnswerArr[i], 10) === index ? style.myAnswerText :style.choicesText}>
                          {String.fromCharCode(index + 65)}. {item}
                        </span>
                      );
                    }
                  }
                  if(parseInt(userAnswerArr[i], 10) === index) {
                    button = (
                      <span className={style.myMultiButton}></span>
                    );
                    break;
                  }else {
                    button = (
                      <span className={style.multiButton}></span>
                    );
                  }
                }
                return (
                  <li key={index} className={style.choicesItem}>
                    {button}
                    {text}
                  </li>
                )
              }
            })
          }
        </ul>
        <AnswerAnalysis
          category={category}
          analysisAnswer={this.props.analysisAnswer}
          />
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Answer/Question/ChooseQuestion.js
 **/